export default __webpack_public_path__ + "locales/vi/DowngradePlanDialog.json?hash=c08fb9dfa70d331f72b8008a22b68806";